module.exports = __webpack_public_path__ + "img/Book.23485edd.svg";